import { Component, Event, EventEmitter, h, Prop, State } from '@stencil/core';
import { ButtonLinkObject, i18nConfig } from '../../../../../interfaces';
import fitText from '../../../../../library/fittext.js';

@Component({
  tag: 'zeudy-cta-overlay-ui',
  styleUrl: 'zeudy-cta-overlay-ui.scss',
  shadow: true,
})
export class CTAOverlayUI {
  private textInput?: HTMLInputElement;

  /**
   * Props
   */
  @Prop() headline: string;
  @Prop() defaultHeadline: string;
  @Prop() bottomText: string;
  @Prop() showButton: boolean;
  @Prop() buttonText: string;
  @Prop() buttonType: 'link' | 'time';
  @Prop() buttonLink: ButtonLinkObject;
  @Prop() allowRewatch: boolean;
  @Prop() allowSkip: boolean;
  @Prop() direction?: 'rtl';
  @Prop() i18n: i18nConfig;
  @Prop() provider: string;
  @Prop() type: string;

  /**
   * State
   */
  @State() isAudioProvider: boolean;

  /**
   * Events
   */
  @Event() skip: EventEmitter<void>;
  @Event() rewatch: EventEmitter<void>;

  /**
   * Shrink text.
   */
  componentDidLoad() {
    let currentType = this.type || this.provider;
    this.isAudioProvider = currentType === 'audio' ? true : false;
    fitText(this.textInput, 3, {
      maxFontSize: this.isAudioProvider === true ? 15 : 20,
      minFontSize: 8,
    });
  }

  handleCTAClick(e) {
    if (!this.buttonLink?.url) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    this.handleLink();
  }

  handleLink() {
    if (this.buttonLink?.opensInNewTab) {
      window.open(this.buttonLink?.url, '_blank');
    } else {
      window.location.href = this.buttonLink?.url;
    }
  }

  render() {
    return (
      <div class="wrapper" ref={el => (this.textInput = el as HTMLInputElement)}>
        <div onClick={e => this.handleCTAClick(e)} class={`overlay ${this.direction === 'rtl' ? 'rtl' : ''} ${this.buttonLink?.url ? 'has-link' : ''}`}>
          <div class={this.isAudioProvider ? 'content is-centered' : 'content'}>
            <h1 part="cta-headline">{this.headline || this.defaultHeadline}</h1>
            {this.bottomText && <p class={this.isAudioProvider && 'is-small'} part="cta-bottom-text" innerHTML={this.bottomText}></p>}
            {this.showButton && (
              <zeudy-player-button
                full
                onClick={e => this.handleCTAClick(e)}
                part="cta-button"
                href={this?.buttonLink?.url}
                target={this?.buttonLink?.opensInNewTab ? '_blank' : '_self'}
                class="button"
                type="primary"
              >
                {this.buttonText}
              </zeudy-player-button>
            )}
          </div>
        </div>
        {!!this.allowRewatch && (
          <div
            class="rewatch"
            onClick={e => {
              e.preventDefault();
              e.stopImmediatePropagation();
              this.rewatch.emit();
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="icon icon-corner-up-left"
            >
              <polyline points="9 14 4 9 9 4"></polyline>
              <path d="M20 20v-7a4 4 0 0 0-4-4H4"></path>
            </svg>
            {this?.i18n?.rewatch}
          </div>
        )}
        {!!this.allowSkip && (
          <div
            class="skip"
            onClick={e => {
              e.preventDefault();
              this.skip.emit();
            }}
          >
            {this?.i18n?.skip} &rarr;
          </div>
        )}
      </div>
    );
  }
}
